import { useRef, useEffect } from 'react';

const useClickOutside = function (ref, callback) {
  let mouseEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'mousedown';
  const callbackRef = useRef(() => {});
  useEffect(() => {
    callbackRef.current = e => {
      if (ref.current && e.target && !ref.current.contains(e.target)) {
        callback();
      }
    };
  }, [callback, ref]);
  useEffect(() => {
    const handleClick = e => callbackRef.current(e);
    document.addEventListener(mouseEvent, handleClick);
    return () => {
      document.removeEventListener(mouseEvent, handleClick);
    };
  }, [mouseEvent]);
  return {
    ref
  };
};
var useClickOutside$1 = useClickOutside;

export { useClickOutside$1 as default };
//# sourceMappingURL=useClickOutside.js.map
